import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { AppSettings } from '../app-settings';
import { AdministrativeService } from './administrative.service';
import { MyEventServices } from './my-event.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private authService: AdministrativeService, private appSettings: AppSettings,
        private myEventService: MyEventServices) { }

    private totalRequests = 0;

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.toLowerCase().indexOf('skiploadingspinner=1') === -1) {
            this.totalRequests++;
        }

        this.myEventService.loadingEvent.next(true);

        if (request.url !== this.appSettings.getTokenUrl()) {
            let tokenized = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.getToken()}`
                }
            });

            return next.handle(tokenized).pipe(
                tap((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        // do stuff with response if you want
                    }
                }, (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401) {
                            this.authService.getNewToken().subscribe(result => {
                                this.setToken(result.access_token)
                            });
                        }
                    }
                }),
                finalize(() => {
                    if (request.url.indexOf('skipLoadingSpinner=1') === -1) {
                        this.totalRequests--;
                    }
                    if (this.totalRequests === 0) {
                        this.myEventService.loadingEvent.next(false);
                    }
                })
            );
        }
        else {
            return next.handle(request).pipe(
                finalize(() => {
                    if (request.url.indexOf('skipLoadingSpinner=1') === -1) {
                        this.totalRequests--;
                    }

                    if (this.totalRequests === 0) {
                        this.myEventService.loadingEvent.next(false);
                    }
                })
            );
        }
    }

    getToken() {
        let token = sessionStorage.getItem("token");

        return token;
    }

    setToken(token: string) {
        sessionStorage.setItem("token", token);
    }
}
